import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addToMyDashboard,
  deleteWidgets,
} from "../../../redux/actions/analytics";

// Import Component
import DashboardPopOver from "../../../component/DashboardPopOver";

function StatusCard({
  id,
  title,
  status,
  statusColor,
  value,
  cardCss,
  menu,
  isDisable,
  setUpdate,
  update,
  tab,
}) {
  const dispatch = useDispatch();

  // Add To My Dashboard
  const handleAddToMyDashboard = () => {
    const request = {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
      payload: {
        analytic_widget_id: id.analytic_widget_id,
      },
    };

    dispatch(addToMyDashboard(request));
  };

  // Delete Widget
  const handleDeleteWidgets = () => {
    const request = {
      dashboard_widget_id: id.analytic_dashboard_id,
      onError: (error) => {
        console.log(error);
      },
      onSuccess: () => {
        setUpdate(update + 1);
      },
    };

    dispatch(deleteWidgets(request));
  };

  return (
    <div className="w-full h-full flex items-center">
      <div className="absolute top-1 right-2 text-base text-[#7D8490]">
        <DashboardPopOver
          handleOnClick={() =>
            tab ? handleDeleteWidgets() : handleAddToMyDashboard()
          }
          menus={menu}
          isDisable={isDisable}
        />
      </div>

      <div className="w-full space-y-3">
        <h2 className="text-sm font-semibold text-[#313439] leading-5">
          {title}
        </h2>
        <div className="space-x-4 flex items-center">
          <h1
            style={{ color: statusColor }}
            className="text-2xl font-semibold leading-5"
          >
            {value ? value : 0}
          </h1>
          {status && (
            <div
              title={status}
              style={{
                borderColor: statusColor,
                color:
                  status === "Completed" ||
                  status === "Overdue" ||
                  status === "Delayed" ||
                  status === "Completed With Delay"
                    ? "#fff"
                    : statusColor,
                backgroundColor:
                  status === "Completed" ||
                  status === "Overdue" ||
                  status === "Delayed" ||
                  status === "Completed With Delay"
                    ? statusColor
                    : "",
              }}
              className={`border-2 text-sm font-semibold leding-5 px-3 py-1 rounded-full max-w-full truncate`}
            >
              {status}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default StatusCard;
